import {
    DELETE_FIELD,
    UPDATE_FIELD,
    SET_ROLE_EXTRA,
    UPDATE_ROLE_EXTRA,
    SET_PAYGRADE,
    SET_START_TIME,
    SET_JOB_REQUESTS,
    SET_DISCOUNT,
    APPEND_JOB_REQUESTS,
} from '../actions/BookingRequest';
import { REMOVE_ADDRESS } from '../actions/ClientData';

const initialState = {
    bookingRequest: {},
    roleData: {},
    minStart: undefined,
    paygrade: undefined,
    paygrades: undefined,
    discount: undefined,
    jobRequest: [],
};

export default function(state = initialState, action) {
    const newState = JSON.parse(JSON.stringify(state));

    // eslint-disable-next-line default-case
    switch (action.type) {
        case DELETE_FIELD:
            delete newState.bookingRequest[action.payload];
            return newState;
        case UPDATE_FIELD:
            newState.bookingRequest[action.payload.field] = action.payload.data;
            return newState;
        case SET_ROLE_EXTRA:
            newState.roleData[action.payload.role] = action.payload.data;
            return newState;
        case UPDATE_ROLE_EXTRA:
            newState.roleData[action.payload.role][action.payload.field] =
                action.payload.data;
            return newState;
        case SET_START_TIME:
            newState.minStart = action.payload.minimal_start_datetime;
            return newState;
        case SET_PAYGRADE:
            newState.paygrade = action.payload;
            return newState;
        case SET_DISCOUNT:
            newState.discount = action.payload;
            return newState;
        case SET_JOB_REQUESTS:
            newState.jobRequest = action.payload;
            return newState;
        case APPEND_JOB_REQUESTS:
            newState.jobRequest = state.jobRequest.concat(action.payload);
            return newState;
        case REMOVE_ADDRESS:
            return {
                ...newState,
                bookingRequest: {
                    ...newState.bookingRequest,
                    address1: null,
                    address2: null,
                    city: null,
                    postcode: null,
                },
            };
    }

    return state;
}
